module.exports = __webpack_public_path__ + "img/creditos-cc.4836eb56.svg";